import { WizardLauncherService } from "../../wizard.launcher.service";
import {
  Component,
  AfterViewInit,
  OnDestroy,
  ChangeDetectorRef,
  OnInit,
  ViewChild,
  EventEmitter,
  ViewContainerRef,
  ComponentFactoryResolver
} from "@angular/core";
import { get, merge } from 'lodash';
import { Subscription } from "rxjs";
import { Router, ActivatedRoute } from "@angular/router";
import { IWizardEntry } from "../../wizard.entry";
import { WizardComponent } from "../../wizard.component";
import { IPAMConfigWizardService } from "../../services/ipam/ipam.configuration.wizard.service";
import { IPAMConfigurationComponent } from "./ipam.configuration/ipam.configuration.component";
import { IPAMResultsComponent } from "./ipam.results/ipam.results.component";


@Component({
  selector: "ipam-configuration-wizard",
  providers: [
    IPAMConfigWizardService
  ],
  templateUrl: "../../wizard.template.html",
  styleUrls: ['../../wizard.component.style.scss', '../../wizard.button.style.scss']
})
export class IPAMConfigurationWizardComponent extends WizardComponent implements OnInit, AfterViewInit, OnDestroy, IWizardEntry {
  wizardConfig:any;
  wizardId:string;
  dataId: any;
  onClose = new EventEmitter<any>();
  widgetConfig:any;
  state: Router;
  openWizard: any;
  subscription: Subscription;
  changeDetectorRef: ChangeDetectorRef;
  closeWizardObj: Subscription;
  activatedRouteSubscription: Subscription;
  wizardService: IPAMConfigWizardService;

  @ViewChild('contentPlaceholder', { read: ViewContainerRef,
static: true }) contentRef: ViewContainerRef;
  @ViewChild('subContentPlaceholder', { read: ViewContainerRef,
static: true }) subContentRef: ViewContainerRef;

  constructor(
    state: Router,
    changeDetectorRef: ChangeDetectorRef,
    wizardService: IPAMConfigWizardService,
    private readonly activatedRoute: ActivatedRoute,
    private readonly launcher: WizardLauncherService,
    private readonly factoryResolver: ComponentFactoryResolver
  ) {
    super();
    this.state = state;
    this.changeDetectorRef = changeDetectorRef;
    this.wizardService = wizardService;
  }

  ngOnInit() {
    this.activatedRouteSubscription = this.activatedRoute.queryParams.subscribe((data) => {
      const defaultParams = merge({}, this.dataId, JSON.parse(get(data, 'defaultParams', "{}")));
      this.wizardService.openWizard(this.wizardId, this.wizardConfig, defaultParams);
    });
    this.closeWizardObj = this.wizardService.closeWizard.subscribe((status) => {
      if(status){
        this.toggleClose();
      }
    });
    this.wizardService.registerToggleListener(this.notifyOnToggleSubContent.bind(this));
  }

  ngAfterViewInit() {
    this.createContentComponent();
    this.changeDetectorRef.detectChanges();
  }

  ngOnDestroy() {
    if(this.closeWizardObj) {
      this.closeWizardObj.unsubscribe();
    }
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
    if(this.activatedRouteSubscription) {
      this.activatedRouteSubscription.unsubscribe();
    }
  }

  get(object, path: string) {
    return get(object, path);
  }

  
  //-------------- Control && Validation -----------------------
  toggleNext() {
    this.wizardService.nextStep();
    this.createContentComponent();
  }

  toggleBack() {
    this.wizardService.previousStep();
    this.createContentComponent();
  }

  toggleFinish() {
    const result = (this.wizardService as IPAMConfigWizardService).onFinish();
    result.subscribe(outcome => {
       
        this.createContentComponent();
    });
  }

  toggleClose() {
    this.wizardService.toggleClose(
      () => this.onClose.emit(true)
    );
  }

  toggleReOpen() {
    this.wizardService.reOpen();
  }

  notifyOnToggleSubContent(onOff) {
    if (onOff) {
      this.createSubContentComponent();
    }
    else {
      this.subContentRef.clear();
    }
  }

  getWizardService() {
    return this.wizardService;
  }
  getFactoryResolver() {
    return this.factoryResolver;
  }
  getContentViewRef() {
    return this.contentRef;
  }
  getSubContentViewRef() {
    return this.subContentRef;
  }


  resolveComponentType(pageId) {
    switch (pageId) {
      case 'ipam.configuration.html':
        return IPAMConfigurationComponent;
      case 'ipam.results.html':
        return IPAMResultsComponent;
      default: {
        console.error('Unrecognized template name:', pageId);
        return null;
      }
    }

  }
}
